module.exports = __webpack_public_path__ + "img/14400.9b4ca606.jpg";